import { getCookie } from 'lib/cookies';
import axios from 'axios';
import axiosInstance from 'configs/axiosConfig';

const config = () => {
  return {
    headers: {
      'Authorization': `Bearer ${getCookie('access')}`,
      'Set-Cookie': getCookie('refresh'),
    },
  };
};

// user api --------------------------------------------------------\\
export function silentRefresh() {
  return axios.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_USER}/silent-refresh`, config());
}

export function signup(dataToSubmit) {
  return axios.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/signup`, dataToSubmit);
}

export function login(dataToSubmit) {
  return axios.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/login`, dataToSubmit);
}

export function logout() {
  return axios.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/logout`, config());
}

export function getMembers() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/members`, config());
}

export function getMemberInfo(idx) {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/member/${idx}`, config());
}

export function updateMemberInfo(idx, dataToSubmit) {
  return axiosInstance.patch(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/member/${idx}`, dataToSubmit, config());
}

export function checkPassword(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/check-pw`, dataToSubmit, config());
}

export function changePassword(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/change-pw`, dataToSubmit, config());
}

export function deleteMemberInfo(idx) {
  return axiosInstance.delete(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/member/${idx}`, config());
}

export function duplicatedId(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/check-dup-id`, dataToSubmit, config());
}

export function duplicatedEmail(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/check-dup-email`, dataToSubmit, config());
}

export function duplicatedPhone(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/check-dup-phone`, dataToSubmit, config());
}
// user api --------------------------------------------------------//

// group api -------------------------------------------------------\\
export function getGroupList() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_GROUP_API}`, config());
}

export function createGroup(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_GROUP_API}`, dataToSubmit, config());
}

export function editGroup(dataToSubmit) {
  return axiosInstance.patch(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_GROUP_API}/update`, dataToSubmit, config());
}

export function updateGroupOrder(dataToSubmit) {
  return axiosInstance.patch(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_GROUP_API}/reorder`, dataToSubmit, config());
}

export function deleteMemberGroup(idx) {
  return axiosInstance.delete(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_GROUP_API}/${idx}`, config());
}
// group api -------------------------------------------------------//

// login log api ---------------------------------------------------\\
export function getLoginLogList() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_LOGINLOG_API}`, config());
}
// login log api ---------------------------------------------------//
